export default __webpack_public_path__ + "static/media/Android.1308a6a0.png";